import * as Sentry from "@sentry/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Sentry.ErrorBoundary>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
